import api from './api';

// ── Auth ──────────────────────────────────────────────────────────────────
export const forgotPasswordSendOTP = (data) => api.post('/auth/doctor/forgot-password/send-otp', data);
export const forgotPasswordReset   = (data) => api.post('/auth/doctor/forgot-password/reset', data);
export const doctorLogin      = (data)  => api.post('/auth/doctor/login', data);
export const doctorRegister        = (data) => api.post('/auth/doctor/register', data);
export const doctorSendRegisterOtp = (data) => api.post('/auth/doctor/send-register-otp', data);
export const staffLogin       = (data)  => api.post('/auth/doctor/staff-login', data);
export const getDoctorMe      = ()      => api.get('/auth/doctor/me');

// ── Profile Setup (4 steps) ───────────────────────────────────────────────
export const updateStep1 = (formData) => api.put('/doctors/setup/step1', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const updateStep2 = (data)  => api.put('/doctors/setup/step2', data);
export const updateStep3 = (data)  => api.put('/doctors/setup/step3', data);
export const updateStep4 = (data)  => api.put('/doctors/setup/step4', data);
export const getMyDoctorProfile = () => api.get('/doctors/me');

// ── Slots ─────────────────────────────────────────────────────────────────
export const generateSlots   = (data)   => api.post('/slots/generate', data);
export const getMySlots      = (params) => api.get('/slots/my', { params });
export const updateSlot      = (id, data) => api.put(`/slots/${id}`, data);
export const updateSlotDelay = (id, delayMinutes) => api.put(`/slots/${id}/delay`, { delayMinutes });
export const deleteSlot      = (id)     => api.delete(`/slots/${id}`);
export const deleteBulkSlots = (data)   => api.delete('/slots/bulk', { data });

// ── Appointments ──────────────────────────────────────────────────────────
export const getDoctorAppointments = (params) => api.get('/appointments/doctor', { params });
export const updateAppointmentStatus = (id, data) => api.put(`/appointments/${id}/status`, data);
export const qrCheckin  = (qrToken)   => api.post('/appointments/qr-checkin', { qrToken });
export const idCheckin  = (bookingId) => api.post('/appointments/id-checkin', { bookingId });

// ── Earnings ──────────────────────────────────────────────────────────────
export const getEarningsSummary      = (params) => api.get('/earnings/summary', { params });
export const getEarningsTransactions = (params) => api.get('/earnings/transactions', { params });
export const getEarningsChart        = (params) => api.get('/earnings/chart', { params });

// ── Staff management ──────────────────────────────────────────────────────
export const listStaff   = ()          => api.get('/staff');
export const createStaff = (data)      => api.post('/staff', data);
export const updateStaff = (id, data)  => api.put(`/staff/${id}`, data);
export const deleteStaff = (id)        => api.delete(`/staff/${id}`);

// ── Clinic Images ────────────────────────────────────────────────────────
export const uploadClinicImages = (formData) => api.post('/doctors/clinic-images', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const deleteClinicImage = (url) => api.delete('/doctors/clinic-images', { data: { url } });

// ── Chat ──────────────────────────────────────────────────────────────────
export const getDoctorConversations = () => api.get('/chat/conversations');
export const getDoctorChatHistory   = (convId, params) => api.get(`/chat/${convId}`, { params });
export const sendDoctorMessage      = (data)    => api.post('/chat/message', data);
export const getDoctorQR = () => api.get('/doctors/qr');
export const deleteConversation = (conversationId, deleteFor = 'me') =>
  api.delete(`/chat/conversation/${conversationId}?deleteFor=${deleteFor}`);
export const uploadDoctorFile       = (formData) => api.post('/chat/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// ── Notifications ─────────────────────────────────────────────────────────
export const getDoctorNotifications = (params) => api.get('/notifications', { params });
export const markDoctorNotifsRead     = ()  => api.put('/notifications/read-all');
export const deleteDoctorNotification = (id) => api.delete(`/notifications/${id}`);
export const deleteAllDoctorNotifs    = ()   => api.delete('/notifications');

// ── Offline Booking ───────────────────────────────────────────────────────
export const offlineBook        = (data)   => api.post('/appointments/offline-book', data);
export const checkOfflinePatient = (phone)  => api.post('/appointments/check-offline-patient', { phone });
export const getAvailableSlots  = (params) => api.get('/appointments/available-slots', { params });
export const getAllSlotsToday    = ()       => {
  const istMs   = Date.now() + 5.5 * 60 * 60 * 1000;
  const todayIST = new Date(istMs).toISOString().split('T')[0];
  return api.get('/appointments/available-slots', { params: { date: todayIST } });
};
export const getOfflineAppointments = (params) => api.get('/appointments/offline', { params });

export const deleteDoctorChatMessage = (messageId) => api.delete(`/chat/message/${messageId}`);
